export const civilityType = {
  SIR: 'SIR',
  MRS: 'MRS',
  MISS: 'MISS',
  NOT_DEFINED: 'NOT_DEFINED',
} as const;

export type Civility = (typeof civilityType)[keyof typeof civilityType];
